// SSE Protocol Constants

// Event delimiter - separates SSE events
export const SSE_EVENT_DELIMITER = "\n\n";

// Data line delimiter - joins multiple data lines within an event
export const SSE_DATA_LINE_DELIMITER = "\n";

// Content type for SSE streams
export const SSE_CONTENT_TYPE = "text/event-stream";

// Text encoding for SSE streams
export const SSE_ENCODING = "utf-8";

// SSE field prefixes
export const SSE_DATA_PREFIX = "data:";
export const SSE_ID_PREFIX = "id:";
export const SSE_EVENT_PREFIX = "event:";

// Event names
export const ABORT_EVENT = "abort";
